// material
import { Box, BoxProps } from '@mui/material';
import { useTheme } from '@mui/system';
import { useGoogleTagManager } from '../hooks/useGoogleTagManager';

// ----------------------------------------------------------------------

interface LogoProps extends BoxProps {
  isOffset?: boolean;
}

export default function LogoInstagram({ sx, isOffset = true }: LogoProps) {
  const { palette } = useTheme();
  const { event } = useGoogleTagManager();

  const mediaInteraction = (media: string) => {
    event({
      path: media,
      event: 'Contact'
    });
  };
  return (
    <Box
      sx={{
        width: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        height: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        ...sx
      }}
    >
      <a
        onClick={() => mediaInteraction('Instagram')}
        target={'_blank'}
        href="https://www.instagram.com/ibanonlinemx/"
        rel="noreferrer"
        aria-label="Icon open instagram"
      >
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="21" cy="21" r="21" fill={palette.primary.main} />
          <g clipPath="url(#clip0_724_10189)">
            <path
              d="M24.9361 10.0625H16.8232C13.09 10.0625 10.0625 13.09 10.0625 16.8232V24.9361C10.0625 28.6694 13.09 31.6969 16.8232 31.6969H24.9361C28.6694 31.6969 31.6969 28.6694 31.6969 24.9361V16.8232C31.6969 13.09 28.6694 10.0625 24.9361 10.0625ZM29.6687 24.9361C29.6687 27.5458 27.5458 29.6687 24.9361 29.6687H16.8232C14.2136 29.6687 12.0907 27.5458 12.0907 24.9361V16.8232C12.0907 14.2136 14.2136 12.0907 16.8232 12.0907H24.9361C27.5458 12.0907 29.6687 14.2136 29.6687 16.8232V24.9361Z"
              fill="white"
            />
            <path
              d="M20.8797 15.4712C17.8928 15.4712 15.4711 17.8929 15.4711 20.8798C15.4711 23.8667 17.8928 26.2884 20.8797 26.2884C23.8666 26.2884 26.2883 23.8667 26.2883 20.8798C26.2883 17.8929 23.8666 15.4712 20.8797 15.4712ZM20.8797 24.2602C19.0164 24.2602 17.4993 22.743 17.4993 20.8798C17.4993 19.0152 19.0164 17.4994 20.8797 17.4994C22.743 17.4994 24.2601 19.0152 24.2601 20.8798C24.2601 22.743 22.743 24.2602 20.8797 24.2602Z"
              fill="white"
            />
            <path
              d="M26.694 15.7861C27.092 15.7861 27.4147 15.4634 27.4147 15.0654C27.4147 14.6674 27.092 14.3447 26.694 14.3447C26.296 14.3447 25.9733 14.6674 25.9733 15.0654C25.9733 15.4634 26.296 15.7861 26.694 15.7861Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_724_10189">
              <rect
                width="21.6344"
                height="21.6344"
                fill="white"
                transform="translate(10.0625 10.0625)"
              />
            </clipPath>
          </defs>
        </svg>
      </a>
    </Box>
  );
}
